import React from "react";
import { useTranslation } from "react-i18next";
import { Img } from "react-image";
import CheckIcon from "src/components/icons/Check";

interface Props {
    imageUrl: string | null;
    isSelected: boolean;
}

export const Image = ({ imageUrl, isSelected }: Props) => {
    const { t } = useTranslation();

    if (imageUrl === null) {
        return null;
    }

    return (
        <div className={"accessories_img_container"}>
            <Img
                className="accessories_img"
                src={imageUrl}
                unloader={<div className="accessories_no_img">{t("AccessoryCardImg.photoComingSoon")}</div>}
            />
            {isSelected && (
                <div className="accessories_added">
                    <CheckIcon className="accessories_added_check" />

                    <span className="accessories_added_text">{t("AccessoryCardImg.addedToVehicle")}</span>
                </div>
            )}
        </div>
    );
};

export default Image;
